import { computed } from 'vue'
import useAppState from '@/hooks/appState'

export default function () {
  const appState = useAppState()

  const modalOpen = computed(() => appState.modal !== null)
  const currentModal = computed(() => appState.modal)

  const openModal = (name, options = {}) => {
    if (appState.modal?.options?.onClose) appState.modal.options.onClose()
    appState.modal = { name, options }
  }

  const closeModal = () => {
    if (appState.modal?.options?.onClose) appState.modal.options.onClose()
    appState.modal = null
  }

  return {
    modalOpen,
    currentModal,
    openModal,
    closeModal
  }
}
